import { sanitizeHtml } from "@/common/helpers/sanitize";
const recollectiveUtils = {
    sanitizeHtml
};
if (!Object.hasOwn(window, "recollectiveUtils")) {
    // Define as readonly to prevent modifications
    Object.defineProperty(window, "recollectiveUtils", {
        writable: false,
        configurable: false,
        enumerable: true,
        value: Object.freeze(recollectiveUtils)
    });
}
